module.exports = __webpack_public_path__ + "img/done-sinistre.0ff61f37.png";